
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { HelmetProvider } from "react-helmet-async";
import Index from "./pages/Index";
import Country from "./pages/Country";
import State from "./pages/State";
import NotFound from "./pages/NotFound";
import ForDogSchools from "./pages/ForDogSchools";
import FindRightSchool from "./pages/FindRightSchool";
import Impressum from "./pages/Impressum";
import Contact from "./pages/Contact";
import Ratgeber from "./pages/Ratgeber";
import Hunderassen from "./pages/Hunderassen";
import DogSchoolDetail from "./pages/DogSchoolDetail";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <HelmetProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/:countryId" element={<Country />} />
              <Route path="/:countryId/:stateId" element={<State />} />
              <Route path="/hundeschule/:city/:schoolId" element={<DogSchoolDetail />} />
              <Route path="/for-dog-schools" element={<ForDogSchools />} />
              <Route path="/find-right-school" element={<FindRightSchool />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/kontakt" element={<Contact />} />
              <Route path="/ratgeber" element={<Ratgeber />} />
              <Route path="/hunderassen" element={<Hunderassen />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </HelmetProvider>
    </LanguageProvider>
  </QueryClientProvider>
);

export default App;
